import { lazy } from "react"
import {
  BIRDS_GROUP_VIEW,
  BIRDS_GROUP_LIST_VIEW,
  EDIT_BIRDS_GROUP_VIEW,
  NEW_BIRDS_GROUP_VIEW,
} from "@/features/birds-groups/routes/route-list.ts"
import AllBirdsGroupsView from "@/features/birds-groups/views/all-birds-groups-view/all-birds-groups-view.tsx"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const BirdsGroupView = lazy(
  () =>
    import(
      "@/features/birds-groups/views/birds-group-view/birds-group-view.tsx"
    ),
)
const EditBirdsGroupView = lazy(
  () =>
    import(
      "@/features/birds-groups/views/edit-birds-group-view/edit-birds-group-view.tsx"
    ),
)
const NewBirdsGroupView = lazy(
  () =>
    import(
      "@/features/birds-groups/views/new-birds-group-view/new-birds-group-view.tsx"
    ),
)
const BottomMenuLayout = lazy(
  () => import("@/layouts/bottom-menu-layout/bottom-menu-layout.tsx"),
)

export const noMenuBirdsGroupsRoutes = [
  {
    path: BIRDS_GROUP_VIEW,
    element: <BirdsGroupView />,
  },
  {
    path: NEW_BIRDS_GROUP_VIEW,
    element: <NewBirdsGroupView />,
  },
  {
    path: EDIT_BIRDS_GROUP_VIEW,
    element: <EditBirdsGroupView />,
  },
]

export const bottomMenuBirdsGroupsRoutes = [
  {
    path: BIRDS_GROUP_LIST_VIEW,
    element: <AllBirdsGroupsView />,
  },
]

export const NO_MENU_LAYOUT_BIRDS_GROUPS_ROUTES = {
  element: <NoMenuLayout />,
  children: noMenuBirdsGroupsRoutes,
}

export const BOTTOM_MENU_LAYOUT_BIRDS_GROUPS_ROUTES = {
  element: <BottomMenuLayout />,
  children: bottomMenuBirdsGroupsRoutes,
}

export const MOBILE_BIRDS_GROUPS_ROUTES = [
  NO_MENU_LAYOUT_BIRDS_GROUPS_ROUTES,
  BOTTOM_MENU_LAYOUT_BIRDS_GROUPS_ROUTES,
]

export const DESKTOP_BIRDS_GROUPS_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: bottomMenuBirdsGroupsRoutes,
  },
]

export const getBirdsGroupsRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_BIRDS_GROUPS_ROUTES : MOBILE_BIRDS_GROUPS_ROUTES
}
